const qldAssessment4Questions = [
    {
        id: 1,
        name: '',
        subtitle: '',
        subtitlePlacement: 'afterInfoTable',
        assessorGuideHtml: `
            <p style="margin:0 0 28px;color:#ff1f1f;font-style:italic;line-height:1.35;">
                Assessors to ensure students adequately demonstrate a basic understanding of how to correctly fit to themselves the specified PPE listed below.
            </p>
            <p style="margin:0 0 28px;color:#ff1f1f;font-style:italic;line-height:1.35;">
                During this task, note if the student asks questions to clarify the instructions provided for fitting PPE. At least one instance of a clarifying question should be observed to satisfy CPCWHS1001 foundation skills.
            </p>
            <p style="margin:0 0 28px;color:#ff1f1f;font-style:italic;line-height:1.35;">
                Assessor to use their professional judgement when considering the student's ability to perform these practical tasks.
            </p>
            <table style="width:100%;border-collapse:collapse;table-layout:fixed;background:#fff;">
                <tbody>
                    <tr>
                        <td colspan="2" style="padding:10px;border:1px solid #111;background:#d8d8d8;color:#111;font-weight:400;">
                            The student should fit the PPE as follows:
                        </td>
                    </tr>
                    <tr>
                        <td style="width:28%;padding:18px 10px;border:1px solid #111;color:#111;vertical-align:middle;">
                            Eye Protection
                        </td>
                        <td style="width:72%;padding:18px 10px;border:1px solid #111;color:#ff1f1f;vertical-align:top;line-height:1.28;">
                            Students must demonstrate safety glasses/goggles being selected and fitted, which comply with AS/NZS 1337. The safety glasses or goggles must adequately cover/protect the eyes. If using safety glasses, the bridge of the safety glasses must sit on the student's nose, and the bent arms must fit around the student's ears.
                        </td>
                    </tr>
                    <tr>
                        <td style="padding:18px 10px;border:1px solid #111;color:#111;vertical-align:middle;">
                            Hearing Protection
                        </td>
                        <td style="padding:18px 10px;border:1px solid #111;color:#ff1f1f;vertical-align:top;line-height:1.28;">
                            Students must demonstrate ear plugs/ear-muffs being selected and fitted, which comply with AS/NZS 1270. If using ear plugs, the student must put an ear plug in each ear according to the manufacturer's instructions. If using ear-muffs, the student must place the muffs over their ears so that they are fully covered and adjust the head piece so that it sits close to the head, where required.
                        </td>
                    </tr>
                    <tr>
                        <td style="padding:18px 10px;border:1px solid #111;color:#111;vertical-align:middle;">
                            Hard Hat
                        </td>
                        <td style="padding:18px 10px;border:1px solid #111;color:#ff1f1f;vertical-align:top;line-height:1.28;">
                            Students must demonstrate a hard hat being selected and fitted, which complies with AS/NZS 1801. The student must fit and adjust the head harness where required, so that the hard hat is positioned comfortably and effectively (e.g. not sitting too high; on straight; not on backwards)
                        </td>
                    </tr>
                    <tr>
                        <td style="padding:18px 10px;border:1px solid #111;color:#111;vertical-align:middle;">
                            High Visibility Vest, Shirt or Jacket
                        </td>
                        <td style="padding:18px 10px;border:1px solid #111;color:#ff1f1f;vertical-align:top;line-height:1.28;">
                            Students must demonstrate a high visibility vest, shirt or jacket being selected and fitted. The vest, shirt or jacket must be sized correctly. If using a vest, it must be secured at the front.
                        </td>
                    </tr>
                </tbody>
            </table>
        `,
        disableTextareaResize: true,
        infoTable: {
            columnWidths: ['26%', '74%'],
            rows: [
                { label: 'Context of the Assessment', value: 'The assessment is a practical task and must be directly observed by your assessor. You must complete this assessment task without input from others.' },
                {
                    label: 'Instructions for Student',
                    valueHtml: `For this task, you need to demonstrate the correct fitting of the following Personal Protective Equipment (PPE):
                    <ul style="margin:8px 0 8px 18px; padding:0;">
                        <li>Eye protection</li>
                        <li>Hearing protection</li>
                        <li>Hard hat</li>
                        <li>High visibility vest, shirt or jacket.</li>
                    </ul>
                    The assessor will ask you to fit one item of PPE at a time. You will fit the PPE and then remove it before fitting the next item. The assessor will record if you have fitted each item of PPE correctly in the space provided below. You must ask at least one question to clarify instructions given by the assessor.`
                },
                { label: 'Criteria for Success', valueHtml: 'To achieve a competent result, you must <u>correctly fit</u> each item of PPE.' },
            ]
        },
        type: 'tableForm',
        textAnswer: true,
        tableForm: {
            studentHeader: ['PPE'],
            assessorHeader: ['PPE', 'Mark C or NYC'],
            header: ['PPE', 'Mark C or NYC'],
            columnWidths: ['42%', '58%'],
            rows: [
                { type: 'static', label: 'Eye Protection', value: '', assessorField: { key: 'eyeProtectionMark', inputType: 'select', options: ['C', 'NYC'] } },
                { type: 'static', label: 'Hearing Protection', value: '', assessorField: { key: 'hearingProtectionMark', inputType: 'select', options: ['C', 'NYC'] } },
                { type: 'static', label: 'Hard Hat', value: '', assessorField: { key: 'hardHatMark', inputType: 'select', options: ['C', 'NYC'] } },
                { type: 'static', label: 'High Visibility Vest, Shirt or Jacket', value: '', assessorField: { key: 'highVisibilityMark', inputType: 'select', options: ['C', 'NYC'] } },
                { type: 'section', label: '<b>Observation<b>' },
                { type: 'static', label: 'Student asked at least one clarifying question when given instructions:', value: '' },
                { label: 'Question/s asked', key: 'clarifyingQuestion', inputType: 'textarea', rows: 4 },
                { assessorOnly: true, label: 'Assessor Comments (if applicable)', key: 'assessorComments', inputType: 'textarea', rows: 4, required: false },
            ]
        }
    },
];

export default qldAssessment4Questions;
